<template>
    <div id="main-content" class="uk-width-expand@l">

        <!-- Description -->
        <div v-if="page.ShopGroup.description" class="uk-grid-medium uk-child-width-1-1" uk-grid>
            <div>
                <div class="uk-card uk-card-body uk-card-default">
                    <article v-html="page.ShopGroup.description" class="uk-article uk-text-small">
                    </article>
                </div>
            </div>
        </div>

        <shop-products @load-page="loadPage"
                       @buy-shop-item="buy"
                       :shop-items="page.ShopItems"
                       :shop-item-prices="page.ShopItemPrices"
                       :shop-items-related="page.ShopItemsRelated"
                       :shop-item-properties="page.ShopItemProperties"
                       :shop-item-warehouses="page.ShopItemWarehouses"
                       :shop-item-tags="page.ShopItemTags"
                       :shop-order-items="page.ShopOrderItems">


            <div slot="show-settings">
                <div class="uk-card uk-card-default uk-card-small uk-card-body">

                        <div class="uk-grid-small uk-child-width-1-1 tm-show-settings"
                         uk-grid>

                        <!-- Результатов на странице -->
                        <div class="uk-flex uk-flex-left">

                            <div class="uk-flex uk-flex-center uk-flex-middle tm-fast-filters">
                                <div class="tm-toggle-switch uk-flex uk-flex-middle">
                                    <label class="tm-mini-switch">
                                        <input @change="setRequestParam('in_stock')" type="checkbox">
                                        <div :class="{'uk-active': params.in_stock === 1}" class="tm-toggle-slider"></div>
                                    </label>
                                </div>
                                <div :class="{'uk-active' : params.in_stock === 1}"><span>Показать только в наличии</span></div>
                            </div>

                        </div>

                        <!-- Сортировка -->
                        <div class="uk-flex uk-flex-left">

                            <div class="uk-flex uk-flex-center uk-flex-middle tm-fast-filters">
                                <div class="tm-toggle-switch uk-flex uk-flex-middle">
                                    <label class="tm-mini-switch">
                                        <input @change="setRequestParam('manufactured')" type="checkbox">
                                        <div :class="{'uk-active': params.manufactured === 1}" class="tm-toggle-slider"></div>
                                    </label>
                                </div>
                                <div :class="{'uk-active': params.manufactured === 1}"><span>Скрыть снятые с производства</span></div>
                            </div>

                        </div>

                        <div class="uk-flex uk-flex-right uk-position-absolute@s tm-items-count">

                            <div class="uk-text-meta"><span>товаров: {{ page.ShopItems.total_items }}</span></div>

                        </div>

                    </div>

                </div>
            </div>

            <selected-shop-filter slot="selected-filters"
                                  @filter-changed="filterChanged"
                                  :filter-properties="page.ShopFilterProperties"
                                  :filter-property-values="page.ShopFilterPropertyValues"
                                  :selected-property-values="page.selectedPropertyValues">
            </selected-shop-filter>
            <shop-filter slot="shop-filters"
                         @filter-changed="filterChanged"
                         :filter-properties="page.ShopFilterProperties"
                         :filter-property-values="page.ShopFilterPropertyValues"
                         :selected-property-values="page.selectedPropertyValues">
            </shop-filter>
        </shop-products>

        <loading
                :show="loading"
                loader-class="tm-loader-wrapper"
                label="">
            <template slot="loading-spinner">
                <div uk-spinner="ratio: 2"></div>
            </template>
        </loading>
    </div>
</template>

<script>

    import Product from './Product/Product'
    import ShopItemsPagination from "./ShopItemsPagination";
    import ShopFilter from "./Filter/ShopFilter";
    import loading from 'vue-full-loading'

    import ShopProductsMixin from './ShopProductsMixin'
    import ShopProducts from "./ShopProducts";
    import SelectedShopFilter from "./Filter/SelectedShopFilter";

    export default {
        name: "ShopGroup",
        mixins: [
            ShopProductsMixin
        ],
        components: {
            SelectedShopFilter,
            ShopProducts,
            ShopFilter,
            ShopItemsPagination,
            Product,
            loading
        },
        props: {
            ShopGroup: {
                type: Object,
                required: true
            },
            ShopFilterProperties: {
                type: Array,
                default() {
                    return []
                }
            },
            ShopFilterPropertyValues: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            selectedPropertyValues: {
                type: [Array, Object],
                default() {
                    return null
                }
            }
        },
        created() {
            this.bindHistoryManipulation(location.href, this.params);
        },
        data() {
            const url_string = window.location.href;
            const url = new URL(url_string);
            const page = parseInt(url.searchParams.get("page"))||1;
            const in_stock = parseInt(url.searchParams.get("in_stock"))||0;
            const manufactured = parseInt(url.searchParams.get("manufactured"))||0;
            return {
                page: {
                    ShopItems: this.ShopItems,
                    ShopGroup: this.ShopGroup,
                    ShopItemPrices: this.ShopItemPrices,
                    ShopItemsRelated: this.ShopItemsRelated,
                    ShopItemProperties: this.ShopItemProperties,
                    ShopFilterProperties: this.ShopFilterProperties,
                    ShopFilterPropertyValues: this.ShopFilterPropertyValues,
                    selectedPropertyValues: this.selectedPropertyValues,
                    ShopItemWarehouses: this.ShopItemWarehouses,
                    ShopItemTags: this.ShopItemTags,
                    ShopOrderItems: this.ShopOrderItems
                },
                params: {
                    propertyValues: this.selectedPropertyValues,
                    page: page,
                    manufactured: manufactured,
                    in_stock: in_stock
                }
            }
        },
        methods: {
            filterChanged(propertyId, propertyValues) {
                this.params.propertyValues = {...this.params.propertyValues, ...{[propertyId]: propertyValues}};
                this.params.page = 1;
                this.fetchShopItems(this.page.ShopGroup.href, this.params, true, false);
            },
            loadPage(page) {
                var reload = false;
                if(this.params.page !== page) {
                    reload = true;
                }
                if(page == 'prev'){
                    this.params.page = this.params.page - 1;
                    reload = true;
                } else if(page == 'next'){
                    this.params.page = this.params.page + 1;
                    reload = true;
                }else{
                    this.params.page = page;
                }
                this.fetchShopItems(this.page.ShopGroup.href, this.params, true, reload);
            },
            setRequestParam(param) {
                if(this.params[param] === 0){
                    this.params[param] = 1;
                }else{
                    this.params[param] = 0;
                }
                this.loadPage(1);
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ShopGroup.vue?0874db99